<template>
  <div role="group" tabindex="-1" :title="name" class="time-picker__group">
    <button
      class="time-picker__button"
      type="button"
      tabindex="-1"
      aria-label="Increment"
      aria-keyshortcuts="ArrowUp"
      @click.prevent="$emit('increment')"
    >
      <font-awesome-icon icon="chevron-up" />
    </button>
    <output
      class="time-picker__output"
      tabindex="0"
      aria-live="off"
      :aria-label="name"
      :aria-valuemin="min"
      :aria-valuemax="max"
      :aria-valuenow="valueNumber"
      :aria-valuetext="value"
      v-on:keydown.arrow-up.prevent="$emit('increment')"
      v-on:keydown.arrow-down.prevent="$emit('decrement')"
      ><bdi>{{ value }}</bdi></output
    >
    <button
      class="time-picker__button"
      type="button"
      tabindex="-1"
      aria-label="Decrement"
      aria-keyshortcuts="ArrowDown"
      @click.prevent="$emit('decrement')"
    >
      <font-awesome-icon icon="chevron-down" />
    </button>
  </div>
</template>

<script>
export default {
  name: "picker",
  props: {
    name: String,
    value: String,
    min: Number,
    max: Number,
  },
  computed: {
    valueNumber: function() {
      if (this.value === "AM") {
        return 0;
      }
      if (this.value === "PM") {
        return 1;
      }
      return this.value + 0;
    },
  },
};
</script>

<style></style>
